import React from 'react';
import { cx } from '@emotion/css';
import { Tab as MUITab, Tabs as MUITabs } from '@mui/material';
import { useStyles } from './Tabs.styles';
export function Tabs(props) {
    const classes = useStyles();
    const handleValueChange = (e, newValue) => {
        props.onTabChange(newValue);
    };
    return (React.createElement(MUITabs, { id: props.id, className: cx(props.className, classes.root), value: props.activeTabIndex, textColor: "primary", onChange: handleValueChange }, props.tabs.map((tab) => (React.createElement(MUITab, { key: tab.id, id: tab.id, label: tab.label, disabled: tab.disabled })))));
}
//# sourceMappingURL=Tabs.js.map